import React from "react";
import manifest from "../../data/manifest";
import ManifestItemCard from "./ManifesItemCard";



const KompassOverview = () => {
  const selectedItems = manifest.slice(7,8); // Oder 1, 2, 3 ...

  // Dynamische Grid-Klasse basierend auf Item-Anzahl
  const getGridColsClass = (count) => {
    if (count === 1) return "md:grid-cols-1";
    if (count === 2) return "md:grid-cols-2";
    return "md:grid-cols-3"; // Fallback oder mehr
  };

  const gridColsClass = getGridColsClass(selectedItems.length);

  return (
    <section className="py-16 px-6 font-mono text-black">
      <div className="max-w-5xl mx-auto space-y-10">
        

        <div className={`grid gap-6 sm:grid-cols-1 ${gridColsClass}`}>
          {selectedItems.map((item) => (
            <ManifestItemCard key={item.id} {...item} />
          ))}
           
        </div>
       
      </div>
    </section>
    
  );
};

export default KompassOverview;
